module.exports = __webpack_public_path__ + "static/media/calendar.5cc8a91c.svg";